import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export function LayoutHeader() {

    const request = {
        method: "POST",
        cache: "no-cache",
        headers: {
            "Content-Type": "application/json"
        }
    };

    const [userName, setUsername] = useState("");
    const [Predio, setUserPredio] = useState("");

    useEffect(() => {
        fetch("/Security/GetUserData", request)
            .then(d => {
                if (d.status === 401)
                    throw "Authorization Error";

                return d.json()
            })
            .then(d => {
                setUsername(d.UserName || "")
                setUserPredio(d.Predio || "")
            })
            .catch(d => {
                if (window.location.pathname !== "/Login" && window.location.pathname !== "/Security/Logout" && window.location.pathname !== "/Redirect/RedirectToApp")
                    window.location = "/Security/Logout";
            });
    }, []);

    const getLogo = () => {

        return <Link to="/Menu">
            <img src="/img/logo.png" alt="Logo" />
        </Link>

    }

    return (
        <header>
            <div className="wis-header-container">
                <div className="wis-header-title">
                    <span className="customer-brand">

                        {getLogo()}

                    </span>

                    <span className="title-separator">| </span>
                    <span id="page-title" className="header-page-title"></span>
                </div>
                <div className="wis-header-user">
                    <span className="wis-header-username">{userName} | Predio: {Predio}</span>
                    <a className="wis-header-logout" href="/Security/Logout">
                        <i className="fas fa-user-times" />
                    </a>
                </div>
            </div>
        </header>
    );
}


// WEBPACK FOOTER //
// ./src/components/LayoutComponents/LayoutHeader.js